import { NumericTextBox, Slider } from '@progress/kendo-react-inputs';
import { TerrainShadingTypeOptions } from '../../../../../types/dropdown-options';
import { UDViewTerrainShadingType } from '../../../../../udView/udview';
import ColorPickerWithDefault from '../../../../components/inputs/ColorPickerWithDefault';
import { DropdownListWithValueField } from '../../../../components/inputs/DropdownListWithValueField';
import { useAppDispatch } from '../../../../hooks/store-hooks';
import { patchFocusedWorkspaceView } from '../../../../state/store';
import { useWorkspace } from '../../hooks/use-view';

export function TerrainShadingSettings() {
    const shading = useWorkspace((x) => x.view.map.terrainShading);
    const dispatch = useAppDispatch();

    return (
        <div className="px-3 py-2" style={{ minWidth: 300 }}>
            <div>Type</div>
            <DropdownListWithValueField
                data={TerrainShadingTypeOptions}
                value={shading.type}
                onChange={(e) => dispatch(patchFocusedWorkspaceView((v) => (v.map.terrainShading.type = e.value)))}
            />

            <div className="mt-2"></div>
            {shading.type === UDViewTerrainShadingType.singleColor && (
                <>
                    <div className="mt-2">Shade at altitude</div>
                    <div className="d-flex gap-2">
                        <NumericTextBox
                            placeholder="Altitude"
                            step={100}
                            format={'# ft'}
                            value={shading.altitude}
                            onChange={(e) =>
                                dispatch(patchFocusedWorkspaceView((v) => (v.map.terrainShading.altitude = e.value as number)))
                            }
                        />
                        <div>
                            <ColorPickerWithDefault
                                value={shading.color}
                                onChange={(e) => dispatch(patchFocusedWorkspaceView((v) => (v.map.terrainShading.color = e.value)))}
                            />
                        </div>
                    </div>
                </>
            )}

            {shading.type === UDViewTerrainShadingType.colorRamp && (
                <div>
                    <div>Opacity {shading.opacity}%</div>
                    <Slider
                        min={0}
                        max={100}
                        value={shading.opacity}
                        className="w-100"
                        step={1}
                        onChange={(e) => dispatch(patchFocusedWorkspaceView((v) => (v.map.terrainShading.opacity = Math.round(e.value))))}
                    />
                </div>
            )}
        </div>
    );
}
